import React from 'react'
import "./Home.css";
import Product from "./Product";


function Home() {
    return (
        <div className="home">
            <div className="home__container">
                <img
                    className="home__image"
                    // src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
                    src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
                    // src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Hero/Fuji_TallHero_Computers_1x._CB432469755_.jpg"

                    alt=""
                />

                <div className="home__row">
                    <Product
                        id="4977850"
                        title="Lifestyle Solutions Collection Grayson Micro-fabric Sofa, Black"
                        price={250.99}
                        rating={3}
                        image="https://m.media-amazon.com/images/I/71YEX0lOVuL._AC_UL480_FMwebp_QL65_.jpg"
                    />
                    <Product
                        id="2245930"
                        title="Magic Keyboard for 12.9-inch iPad Pro (4th Generation) - US English"
                        price={398.99}
                        rating={5}
                        image="https://m.media-amazon.com/images/I/71vh06cKISL._AC_UY327_FMwebp_QL65_.jpg"
                    />
                    <Product
                        id="388354345"
                        title="Nike Men's Air Ring Leader Low Basketball Shoe"
                        price={98.99}
                        rating={4}
                        image="https://m.media-amazon.com/images/I/61WJhWjZBzL._AC_UL480_FMwebp_QL65_.jpg"
                    />
                </div>

                <div className="home__row">
                    <Product
                        id="3421341"
                        title=" Samsung 34 CJ791 Ultrawide Curved Gaming Monitor, 100Hz Refresh, QLED Computer Monitor"
                        price={731.96}
                        rating={5}
                        image="https://m.media-amazon.com/images/I/91-hWcNu2yL._AC_UY327_FMwebp_QL65_.jpg"
                    />
                    <Product
                        id="49345094"
                        title="Samsung Electronics Japan QH65R Plasma/LCD/CRT TV"
                        price={2329.0}
                        rating={4}
                        image="https://m.media-amazon.com/images/I/61SQeL-zNyL._AC_UY327_FMwebp_QL65_.jpg"
                    />
                </div>



                <div className="home__row">
                    <Product
                        id="90829232"
                        title="Polk Audio T15 Watt HomeBookshelf Speakers Dolby and DTS Surround | Wall-Mountable| Pair, Black"
                        price={94.98}
                        rating={4}
                        image="https://m.media-amazon.com/images/I/6179HhYbVrL._AC_UY327_FMwebp_QL65_.jpg"
                    />
                    <Product
                        id="90829332"
                        title="Giantex Portable Mini Compact Twin Tub Washing Machine 17.6lbs"
                        price={894.98}
                        rating={3}
                        image="https://m.media-amazon.com/images/I/61ydHx1s19L._AC_UL480_FMwebp_QL65_.jpg"
                    />
                    <Product
                        id="90829032"
                        title="BESTOPE Makeup Brushes 16 PCs Makeup Brush Set Prem Make Up Brushes Kit (Rose Golden)"
                        price={15.98}
                        rating={4}
                        image="https://images-na.ssl-images-amazon.com/images/I/51ILxjKmzGL._AC_US240_FMwebp_QL65_.jpg"
                    />
                </div>

                <div className="home__row">

                    <Product
                        id="340341"
                        title="SAT Prep Black Book: The Most Effective SAT Strategies Ever Published"
                        price={21.96}
                        rating={5}
                        image="https://images-na.ssl-images-amazon.com/images/I/41EgtC-0V+L._SX258_BO1,204,203,200_.jpg"
                    />
                    <Product
                        id="342241"
                        title="Pinzon 6 Piece Blended Egyptian Cotton Bath Towel Set - Grey"
                        price={36.96}
                        rating={3}
                        image="https://m.media-amazon.com/images/I/91qqiXudI0L._AC_UL480_FMwebp_QL65_.jpg"
                    />

                    <Product
                        id="391341"
                        title="3 Set Luggage Suit Cases"
                        price={131.96}
                        rating={5}
                        image="https://m.media-amazon.com/images/I/91xmehL1VFL._AC_UL480_FMwebp_QL65_.jpg"
                    />
                </div>


                <div className="home__row">
                    <Product
                        id="3411341"
                        title=" BenQ 27 Inch IPS Monitor | 1080P | Proprietary Eye-Care Tech | Ultra-"
                        price={431.96}
                        rating={2}
                        image="https://m.media-amazon.com/images/I/71BuyRgSzdL._AC_UL480_FMwebp_QL65_.jpg"
                    />
                    <Product
                        id="4911094"
                        title="Nikon D3500 W/ AF-P DX NIKKOR 18-55mm f/3.5-5.6G VR Black"
                        price={229.0}
                        rating={3}
                        image="https://m.media-amazon.com/images/I/71TSinb4usL._AC_UL480_FMwebp_QL65_.jpg"
                    />
                </div>

            </div>
        </div>
    )
}

export default Home
